import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import type { UUID } from '@cobliteam/common-types';

import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';
import GraphQLDeviceRequester from '@cobliteam/api-lib/src/dashboard/device/GraphQLDeviceRequester';

const graphQLDeviceRequester = new GraphQLDeviceRequester();

const QUERY_KEY = 'FUSCA_DEVICES';

const useQueryDevices = ({
  vehicleGroupIds,
  includeLastMovingStateTime = true,
  includeLastLocation = true,
  includeVehicle = true,
  includeDisablerStatus = false,
  options,
}: {
  vehicleGroupIds?: UUID[];
  includeLastMovingStateTime?: boolean;
  includeLastLocation?: boolean;
  includeVehicle?: boolean;
  includeDisablerStatus?: boolean;
  options?: UseQueryOptions<DeviceFragment[]>;
}) => {
  return useQuery<DeviceFragment[]>({
    queryKey: [
      QUERY_KEY,
      includeLastMovingStateTime,
      includeLastLocation,
      includeVehicle,
      includeDisablerStatus,
      vehicleGroupIds,
    ],
    queryFn: () =>
      graphQLDeviceRequester.getDevices({
        includeLastMovingStateTime,
        includeLastLocation,
        includeVehicle,
        includeDisablerStatus,
        vehicleGroupIds,
      }),
    ...options,
  });
};

export default { useQueryDevices };

export { useQueryDevices };
